import { TRANSFER_REQUEST } from './../constants';
import { handleActions } from "redux-actions"

export const transfers  = handleActions(
  {
    [ TRANSFER_REQUEST ]: (state, action) => {
      if (Object.keys(action.payload).length === 0) {
        return [ ...state ]
      } else {
        return [...state]
      }
    },
    // [ GET_OTP_TAXES ]: (state, action) => state
  }, []
)